import Splide from '@splidejs/splide';
import SimpleLightbox from 'simplelightbox/dist/simple-lightbox.esm';
import './profile/v2-web-profile-sticky-footer.js';

if (window.navigator.userAgent.indexOf('Mobile') === -1) {
	const lightbox = new SimpleLightbox('#profile-pictures li', {
		sourceAttr:        'data-src',
		fadeSpeed:         100,
		animationSpeed:    150,
		overlayOpacity:    1,
		widthRatio:        1,
		heightRatio:       1,
		swipeClose:        true,
		scaleImageToRatio: true,
		nav:               window.navigator.userAgent.indexOf('Mobile') === -1,
	});

	lightbox.on('change.simplelightbox', function(event) {
		const target     = event.target;
		const attributes = target.dataset.attributes;

		if (attributes) {
			const stringify = JSON.parse(attributes);

			const event = new CustomEvent('lightboxSlideChange', {
				detail: stringify,
			});

			document.dispatchEvent(event);
		}
	});

	lightbox.on('show.simplelightbox', function() {
		document.body.classList.add('lightbox-open');
	});

	lightbox.on('close.simplelightbox', function() {
		setTimeout(function() {
			document.body.classList.remove('lightbox-open');
		}, 350);
	});
}

let splide = new Splide('.splide', {
	type:        'loop',
	perPage:     1,
	lazyLoad:    'nearby',
	cover:       true,
	fixedHeight: '600px',
	pagination:  false,
});

let bar = splide.root.querySelector('.progress-bar');

splide.on('mounted move', function() {
	let end         = splide.Components.Controller.getEnd() + 1;
	bar.style.width = String(100 * (splide.index + 1) / end) + '%';
});

splide.on('move', function(newIndex) {
	const activeSlide = splide.Components.Slides.getAt(newIndex);

	if (activeSlide) {
		const attributes = activeSlide.slide.dataset.attributes;
		const stringify  = JSON.parse(attributes);

		const event = new CustomEvent('splideSlideChange', {
			detail: stringify,
		});

		document.dispatchEvent(event);
	}
});

splide.mount();

const toggleBtnElements = document.querySelectorAll('.vanilla-collapse-toggle');

toggleBtnElements.forEach(function(toggleButton) {
	let targetId = toggleButton.dataset.collapseTargetId,
		target   = document.getElementById(targetId);

	toggleButton.addEventListener('click', function(e) {
		e.preventDefault();

		target.classList.toggle('show');
		toggleButton.classList.toggle('opened');
	});
});

/**
 * Email
 */
const emailButton = document.getElementById('showEmailButton');
const emailHidden = document.getElementById('emailHidden');

if (emailButton && emailHidden) {
	emailButton.addEventListener('click', function() {
		const email      = this.dataset.email;
		const link       = this.dataset.link;
		const attributes = this.dataset.attributes;

		const emailDecoded = atob(email);
		const linkDecoded  = atob(link);

		emailHidden.textContent = emailDecoded;
		emailHidden.href        = linkDecoded;

		emailHidden.setAttribute('data-attributes', attributes);
		emailHidden.classList.add('js-analytics-click');

		document.dispatchEvent(new Event('analytics:refresh'));

		this.remove();
	});
}

/**
 * Phone
 */
const phoneButtons = document.querySelectorAll('.showPhoneButton');

phoneButtons.forEach((phoneButton) => {
	phoneButton.addEventListener('click', function() {
		const phoneDataSet = this.dataset.phone;
		const linkDataSet  = this.dataset.link;

		const phone = atob(phoneDataSet);
		let link    = null;

		if (linkDataSet) {
			link = atob(linkDataSet);
		}

		const container = this.closest('.showPhone');

		if (!container) {
			return false;
		}

		const phoneLink = container.querySelector('.showPhoneLink');
		const phoneText = container.querySelector('.showPhoneText');

		if (link) {
			phoneLink.href = link;
		} else {
			phoneLink.href = 'tel:' + phone.replace(/[^\d+]/g, '');
		}

		phoneText.textContent = phone;

		const newPhoneLink = document.createElement('a');

		newPhoneLink.innerHTML = phoneLink.innerHTML;
		newPhoneLink.className = phoneLink.className;
		newPhoneLink.href      = phoneLink.href;

		newPhoneLink.classList.add('hover:text-main-500');

		container.innerHTML = newPhoneLink.outerHTML;

		this.remove();
	});
});

const phoneButton = document.querySelectorAll('.showPhoneButtonSingle');

phoneButton.forEach((phoneButton) => {
	phoneButton.addEventListener('click', function() {
		const phoneDataSet = this.dataset.phone;
		const linkDataSet  = this.dataset.link;
		const phone        = atob(phoneDataSet);
		let link           = null;

		if (linkDataSet) {
			link = atob(linkDataSet);
		}

		let preLink;

		if (link) {
			preLink = link;
		} else {
			preLink = 'tel:' + phone.replace(/[^\d+]/g, '');
		}

		const newPhoneLink = document.createElement('a');

		newPhoneLink.innerHTML = this.innerHTML;
		newPhoneLink.className = this.className;
		newPhoneLink.href      = preLink;
		newPhoneLink.text      = phone;

		this.insertAdjacentElement('afterend', newPhoneLink);
		this.remove();
	});
});
